import { render } from "./WatIkBouwPieChart.vue?vue&type=template&id=b19904be&scoped=true"
import script from "./WatIkBouwPieChart.vue?vue&type=script&lang=js"
export * from "./WatIkBouwPieChart.vue?vue&type=script&lang=js"

import "./WatIkBouwPieChart.vue?vue&type=style&index=0&id=b19904be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19904be"]])

export default __exports__